<template>
  <v-card
    :height="setHeight"
    class="rounded-xl"
    outlined
    min-width="100%"
    tile
  >
    <v-card-title>
      <h6
        class="mx-auto text-caption text-uppercase text--secondary"
      >
        Статусы комиссии
      </h6>
    </v-card-title>
    <v-card-text
      style="height: calc(100% - 50px);"
      v-if="Object.keys(this.technical_map).length > 0"
      class="d-flex text-center overflow-auto"
      :class="list_heads_ed_progs_statuses.length < 4 ? 'justify-center align-center' : ''"
    >
      <v-list dense>
        <v-subheader class="text-subtitle-1 text-uppercase d-flex justify-center">Заведующий кафедрой</v-subheader>
        <template v-for="(item, index) in list_heads_departments_statuses">
          <v-badge
            class="ma-2 custom-badge"
            :color="setStatus(item.data.status_review).color"
            :value="item.message_commission"
            avatar
            bordered
            overlap
          >
            <template v-slot:badge>
              <v-avatar>
                <v-icon size="15px">
                  fa-comments
                </v-icon>
              </v-avatar>
            </template>
            <v-chip
              @click="setCommentCommission(item)"
              :key="'head_dep' + index"
              class="pa-4"
              :color="setStatus(item.data.status_review).color"
              outlined
            >
              <v-icon left>
                fa fa-user
              </v-icon>
              {{ item.person }}
              <v-icon right>
                {{ setStatus(item.data.status_review).icon }}
              </v-icon>
            </v-chip>
          </v-badge>
        </template>
        <v-subheader class="text-subtitle-1 text-uppercase text-center d-flex justify-center">Руководители Образовательных программ</v-subheader>
        <template
          v-for="(item, index) in list_heads_ed_progs_statuses"
        >
          <v-badge
            class="ma-2 custom-badge"
            :color="setStatus(item.data.status_review).color"
            :value="item.message_commission"
            avatar
            bordered
            overlap
          >
            <template v-slot:badge>
              <v-avatar>
                <v-icon size="15px">
                  fa-comments
                </v-icon>
              </v-avatar>
            </template>
            <v-chip
              @click="setCommentCommission(item)"
              :key="'head_ed_prog' + index"
              :color="setStatus(item.data.status_review).color"
              class="pa-4"
              outlined
            >
              <v-icon left>
                fa fa-user
              </v-icon>
              {{ item.person }} ({{item.management}})
              <v-icon right>
                {{ setStatus(item.data.status_review).icon }}
              </v-icon>
            </v-chip>
          </v-badge>
        </template>
        <v-subheader class="text-subtitle-1 text-uppercase text-center d-flex justify-center">Специалист ЦЭОиДПО</v-subheader>
        <v-badge
          class="ma-2"
          :color="setStatus(methodologist.data.status_review).color"
          :value="methodologist.message_commission"
          avatar
          bordered
          overlap
        >
          <template v-slot:badge>
            <v-avatar>
              <v-icon size="15px">
                fa-comments
              </v-icon>
            </v-avatar>
          </template>
          <v-chip
            @click="setCommentCommission(methodologist)"
            class="pa-4"
            :color="setStatus(methodologist.data.status_review).color"
            outlined
          >
            <v-icon left>
              fa fa-user
            </v-icon>
            {{ methodologist.person }}
            <v-icon right>
              {{ setStatus(methodologist.data.status_review).icon }}
            </v-icon>
          </v-chip>
        </v-badge>
      </v-list>
    </v-card-text>
    <v-card-text v-else style="height: calc(100% - 40px);" class="d-flex justify-center align-center">
      <v-alert
        icon="fa fa-exclamation-circle"
        class="text-h6"
        rounded="xl"
        outlined
        color="teal"
      >
        Статусы комиссии не определены
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
    import _ from "lodash";
    import {mapState, mapMutations} from "vuex";

    export default {
        name: "CardStatusesCommission",
        data: () =>({

        }),
        computed: {
            ...mapState({
                technical_map: state => state.studyEstEukTechMap.technical_map,
                data_comment: state => state.studyEstEukTechMapCommission.data_comment,
            }),
            list_heads_departments_statuses(){
                if (Object.keys(this.technical_map).length > 0){
                    return _.filter(this.technical_map.commission, ['data.euk_role_person', 1])
                }
            },
            list_heads_ed_progs_statuses(){
                if (Object.keys(this.technical_map).length > 0){
                    return _.filter(this.technical_map.commission, ['data.euk_role_person', 2])
                }
            },
            methodologist(){
                if (Object.keys(this.technical_map).length > 0){
                    return _.find(this.technical_map.commission, ['data.euk_role_person', 3])
                }
            },
            setHeight(){
               if (Object.keys(this.technical_map).length > 0){
                   return '500px'
               }
               return '180px'
            }
        },
        methods: {
            ...mapMutations({
                setDataComment: 'studyEstEukTechMapCommission/setDataComment'
            }),
            setStatus(status){
                if (status === 1) {
                    return {color: 'orange', name: 'Рассматривается', icon: 'fa fa-exclamation-circle'}
                } else if (status  === 2) {
                    return {color: 'green', name: 'Одобрено', icon: 'fa fa-check-circle'}
                } else if (status  === 3) {
                    return {color: 'red', name: 'Отклонено', icon: 'fa fa-times-circle'}
                } else if (status === 4) {
                  return {color: 'orange', name: 'Рассматривается', icon: 'fa fa-exclamation-circle'}
                }
            },
            setCommentCommission(item){
                this.setDataComment(item)
            }
        }
    }
</script>

<style scoped>
  >>> .v-badge__badge {
    font-size: 20px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
  }
</style>